






























import Vue from "vue"
import { vueWith } from "./../vueWith"

export default vueWith<{
  // $refs: { table: TableComponentMethods },
}>().extend({
  components: {
    // TableComponent,
  },
  props: {
    initValue: String,
  },
  data() {
    return {
      //
      username: "",
    }
  },

  computed: {
  },

  /** Vue構築完了時の処理 */
  created: function init() {
    const cookies = decodeURI(document.cookie).split(";")
    for (let cookie of cookies) {
      // 先頭の空白除去
      cookie = cookie.replace(/^\s+/, "")
      const tmp = cookie.split("=")
      if (tmp[0] === "username") {
        this.username = tmp[1]
      }
    }
  },

  methods: {

    // 子から呼ばれる ---------------------------------------------

  },
})


